import React, { useEffect } from 'react';

import './error.css'
import logo from '../../assets/msw-logo.png';

const Error = ({ message = 'You are not allowed to access this page.' }) => {
    useEffect(() => {
        clearTimeout();
    });

    return (
        <div className='error'>
            <div className='icon'>
                <i className='fa fa-exclamation-triangle'></i>
            </div>

            <p className='message'>{message}</p>

            <div className='footer'>
                <div className='logo'>
                    <img src={logo} alt='Logo' />
                </div>
                <p>&copy; Megasportsworld 2024.</p>
            </div>
        </div>
    )
}

export default Error;
